/* Generated from Java with JSweet 2.3.5 - http://www.jsweet.org */
import { Library } from '../../Library';
import { Aai20Components } from '../../asyncapi/v2/models/Aai20Components';
import { Aai20Document } from '../../asyncapi/v2/models/Aai20Document';
import { Aai20SchemaDefinition } from '../../asyncapi/v2/models/Aai20SchemaDefinition';
import { AbstractCommand } from '../AbstractCommand';
import { LoggerCompat } from '../../compat/LoggerCompat';
import { MarshallCompat } from '../../compat/MarshallCompat';
import { Document } from '../../core/models/Document';
import { AaiComponents } from '../../asyncapi/models/AaiComponents';
import { Node } from '../../core/models/Node';
import { AaiSchema } from '../../asyncapi/models/AaiSchema';

/**
 * A command used to add a new definition in a document. Source for the new
 * definition must be provided. This source will be converted to an AAI
 * definition object and then added to the data model.
 * @author laurent.broudoux@gmail.com
 * @extends AbstractCommand
 * @class
 */
export class AddSchemaDefinitionCommand_Aai20 extends AbstractCommand {
    public _defExisted : boolean;

    public _newDefinitionName : string;

    public _newDefinitionObj : any;

    public _nullComponents : boolean;

    public constructor(definitionName? : any, from? : any) {
        if(((typeof definitionName === 'string') || definitionName === null) && ((from != null) || from === null)) {
            let __args = arguments;
            super();
            if(this._defExisted===undefined) this._defExisted = false;
            if(this._newDefinitionName===undefined) this._newDefinitionName = null;
            if(this._newDefinitionObj===undefined) this._newDefinitionObj = null;
            if(this._nullComponents===undefined) this._nullComponents = false;
            if(this._defExisted===undefined) this._defExisted = false;
            if(this._newDefinitionName===undefined) this._newDefinitionName = null;
            if(this._newDefinitionObj===undefined) this._newDefinitionObj = null;
            if(this._nullComponents===undefined) this._nullComponents = false;
            (() => {
                this._newDefinitionName = definitionName;
                this._newDefinitionObj = from;
            })();
        } else if(((typeof definitionName === 'string') || definitionName === null) && from === undefined) {
            let __args = arguments;
            super();
            if(this._defExisted===undefined) this._defExisted = false;
            if(this._newDefinitionName===undefined) this._newDefinitionName = null;
            if(this._newDefinitionObj===undefined) this._newDefinitionObj = null;
            if(this._nullComponents===undefined) this._nullComponents = false;
            if(this._defExisted===undefined) this._defExisted = false;
            if(this._newDefinitionName===undefined) this._newDefinitionName = null;
            if(this._newDefinitionObj===undefined) this._newDefinitionObj = null;
            if(this._nullComponents===undefined) this._nullComponents = false;
            (() => {
                this._newDefinitionName = definitionName;
            })();
        } else if(definitionName === undefined && from === undefined) {
            let __args = arguments;
            super();
            if(this._defExisted===undefined) this._defExisted = false;
            if(this._newDefinitionName===undefined) this._newDefinitionName = null;
            if(this._newDefinitionObj===undefined) this._newDefinitionObj = null;
            if(this._nullComponents===undefined) this._nullComponents = false;
            if(this._defExisted===undefined) this._defExisted = false;
            if(this._newDefinitionName===undefined) this._newDefinitionName = null;
            if(this._newDefinitionObj===undefined) this._newDefinitionObj = null;
            if(this._nullComponents===undefined) this._nullComponents = false;
        } else throw new Error('invalid overload');
    }

    /**
     * 
     * @param {Document} document
     */
    public execute(document : Document) {
        LoggerCompat.info("[AddSchemaDefinitionCommand_Aai20] Executing.");
        let doc : Aai20Document = <Aai20Document>document;
        if(this.defExists(doc)) {
            LoggerCompat.info("[AddSchemaDefinitionCommand_Aai20] Definition with name %s already exists.", this._newDefinitionName);
            this._defExisted = true;
            return;
        }
        if(this.isNullOrUndefined(doc.components)) {
            doc.components = doc.createComponents();
            this._nullComponents = true;
        } else {
            this._nullComponents = false;
        }
        let components : Aai20Components = <Aai20Components>doc.components;
        let definition : Aai20SchemaDefinition = components.createSchemaDefinition(this._newDefinitionName);
        Library.readNode(this._newDefinitionObj, definition);
        components.addSchemaDefinition(this._newDefinitionName, definition);
    }

    /**
     * 
     * @param {Document} document
     */
    public undo(document : Document) {
        LoggerCompat.info("[AddSchemaDefinitionCommand_Aai20] Reverting.");
        if(this._defExisted) {
            return;
        }
        let doc : Aai20Document = <Aai20Document>document;
        if(this._nullComponents) {
            doc.components = null;
        }
        (<Aai20Components>doc.components).removeSchemaDefinition(this._newDefinitionName);
    }

    /*private*/ defExists(document : Aai20Document) : boolean {
        if(this.isNullOrUndefined(document.components)) {
            return false;
        }
        let components : Aai20Components = <Aai20Components>document.components;
        return !this.isNullOrUndefined(components.getSchemaDefinition(this._newDefinitionName));
    }
}
AddSchemaDefinitionCommand_Aai20["__class"] = "io.apicurio.datamodels.cmd.commands.AddSchemaDefinitionCommand_Aai20";
AddSchemaDefinitionCommand_Aai20["__interfaces"] = ["io.apicurio.datamodels.cmd.ICommand"];




